import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	item: {
		padding: "6px",
		borderRadius: "4px",
		"&:hover": {
			background: newColors.grey[100]
		}
	}
}))

export default useStyles
